

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useAuthState } from '../../../../../../Helper/Context';
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL';
import { LocationDDL } from '../../../../../../Components/CommonDDL/LocationDDL';
import { PillerDDL } from '../../../../../../Components/CommonDDL/PillerDDL';
import { PoleEleMasterPostDataAPI } from '../../../../../../Redux/ElectricalSlice/PoleSlice';
import { WorkNameDDL } from '../../../../../../Components/CommonDDL/WorkNameDDL';
import { WorkTypeDDL } from '../../../../../../Components/CommonDDL/WorkTypeDDL';
import moment from 'moment';
import { Post_M_ELEC_WardWiseToken_InsertDataAPI } from '../../../../../../Redux/WardWiseTokenSlice/WardWiseTokenSlice';
import { AstricSign } from '../../../../../../Helper/AstricSign';


export default function WardWiseTokenModal(props) {

    const { item, EditIcon, Flag, handleIsPost, rowData, open, handleOnCloseClick } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch();

    // const [rowData, setRowData] = useState(Flag === 'Update' ? item : '')
    // console.log('DashboardName ##################', Flag, rowData)

    const [PoleNumber, setPoleNumber] = useState(Flag === 'Update' ? rowData.poleNumber : '')

    const [Isloading, setIsloading] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [APIToken, setAPIToken] = useState(Flag === 'Update' ? rowData.token : '')
    const [API, setAPI] = useState(Flag === "Update" ? rowData?.api : '')
    const [Session, setSession] = useState(Flag === 'Update' ? rowData.sessionID : '')
    const [Domain, setDomain] = useState(Flag === "Update" ? rowData?.domainID : '')


    const [WardName, setWardName] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })

    const [WorkName, setWorkName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handlePost = () => {
        const data = {
            M_ELEC_WardWiseTokenID : Flag == "Update" ? rowData?.m_eleC_WardWiseTokenID :"0",
            M_FinancialYearID: moment().format('YYYY'),
            M_MonthID: moment().format('MM'),
            M_WardID: WardName?.ID,
            Token: APIToken,
            API: API,
            SessionID: Session,
            DomainID: Domain,
            M_UserID: UserID,
            token: token,
            Flag : Flag,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
        }
        dispatch(Post_M_ELEC_WardWiseToken_InsertDataAPI({ data }))
    }

    return (


        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h5 className="modal-title pt-1" id="staticBackdropLabel">
                            {Flag === "Update" ? "Update" : "Add"} Ward Wise Token
                        </h5>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row col-12 ">


                                {/* <div className="col-12">
                                    <div className="form-group">
                                        <WorkTypeDDL
                                            WorkType={WorkType}
                                            setWorkType={setWorkType}
                                            isDisplay={true}
                                            Flag={Flag}
                                            IsDisabled={true}
                                        />
                                    </div>
                                </div> */}

                                <div className="col-12">
                                    <div className="form-group">
                                        <WardNameDataDDL
                                            WardName={WardName}
                                            setWardName={setWardName}
                                            HWard='0'
                                            WLable=''
                                            Type="Electrical"
                                            APIFlag="Master"
                                            IsPost={IsPost}
                                            rowData={rowData}
                                            Flag={Flag}
                                            disabled={Flag == "Update"}
                                            IsDisabled={true}
                                        />
                                    </div>
                                </div>


                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Token</b> <AstricSign/></label>
                                        <input type="text"

                                            className="form-control"
                                            id="PoleNumber"
                                            value={APIToken}
                                            onChange={(e) => setAPIToken(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Session</b><AstricSign/></label>
                                        <input type="text"

                                            className="form-control"
                                            id="DesignationName"
                                            value={Session}
                                            onChange={(e) => setSession(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>API</b><AstricSign/></label>
                                        <input type="text"
                                            disabled={Flag == "Update"}
                                            className="form-control"
                                            id="DesignationName"
                                            value={API}
                                            onChange={(e) => setAPI(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Domain</b><AstricSign/></label>
                                        <input type="text"
                                            disabled={Flag == "Update"}
                                            className="form-control"
                                            id="DesignationName"
                                            value={Domain}
                                            onChange={(e) => setDomain(e.target.value)}
                                        />
                                    </div>
                                </div>

                            </div>

                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost(Flag)}
                                        disabled={
                                            WardName?.ID == 0 
                                            || APIToken == "" || APIToken == null
                                            || Session == "" || Session == null
                                            || API == "" || API == null
                                            || Domain == "" || Domain == null
                                        }
                                    >{Flag === "Update" ? "Update" : "Add"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            {/* )} */}


        </Popup>
    )

}